module.exports = __webpack_public_path__ + "img/popularize-pic-03.54f90c7c.png";